import { cn } from '../../lib/cn.js';

interface ToolbarButtonProps {
  readonly icon: React.ReactNode;
  readonly label: string;
  readonly onClick: () => void;
  readonly active?: boolean;
  readonly accent?: boolean;
  readonly ariaPressed?: boolean;
  readonly srLabel?: string;
}

export function ToolbarButton({
  icon,
  label,
  onClick,
  active,
  accent,
  ariaPressed,
  srLabel,
}: ToolbarButtonProps): JSX.Element {
  if (accent) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-pressed={ariaPressed}
        className={cn(
          'flex items-center gap-1.5 rounded-lg px-3.5 py-1.5 text-xs font-semibold transition-all',
          active
            ? 'bg-accent text-white shadow-glow'
            : 'bg-gradient-to-r from-accent to-accent-dim text-white shadow-glow hover:-translate-y-0.5 hover:shadow-lg',
        )}
      >
        {icon}
        <span>{label}</span>
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={ariaPressed}
      aria-label={srLabel ?? label}
      className={cn(
        'flex h-8 items-center gap-1.5 rounded-lg border px-2.5 text-xs font-medium transition-colors',
        active
          ? 'border-accent/40 bg-accent/10 text-text-primary'
          : 'border-border-subtle bg-surface text-text-secondary hover:border-border-default hover:bg-hover hover:text-text-primary',
      )}
    >
      {icon}
      {label && <span>{label}</span>}
    </button>
  );
}
